import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

function SummaryPage() {
    const location = useLocation();
    const zendeskId = location.state?.data;

    return (
        <div className="center-content" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <img src="https://cloud9requests.symphony.com/Cloud9_Logo.png" alt="C9 Logo" width="300" height="100"></img>
            <p>Form Submitted Your reference No is : {zendeskId.zendesk_ticket_id}</p>
        </div>
    );
}

export default SummaryPage;
